import React from 'react';
import { twMerge } from 'tailwind-merge';
import RingilButton from '@components/ringil3/Buttons/RingilButton.tsx';
import SvgCloseThin from '@icons/close-thin.svg?react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';

interface ComponentProps {
  onClick: () => void;
  dataTestId?: string;
  /** Merged over the defaults — used where the container's padding differs from the dialog's 24px. */
  className?: string;
}

/**
 * The close cross used by every overlay — dialogs and side panels alike.
 *
 * A link-mode button so it hovers like the rest of the app, around a 12px thin cross with a 32px
 * hit area; the negative margins pull that padding back out so the glyph still sits on the
 * container's own 24px edge, and h-auto stops the link button's 48px box from stretching the
 * headline row.
 */
const CloseButton: React.FC<ComponentProps> = ({ onClick, dataTestId, className }) => {
  const { tr } = useTranslationLgs();
  return (
    <RingilButton
      mode={'link'}
      onClick={onClick}
      icon={<SvgCloseThin className={'h-3 w-3'} />}
      tooltip={tr(`CloseButton.close`, `Close`)}
      className={twMerge('-my-2 -mr-2 h-auto p-2', className)}
      dataTestId={dataTestId}
    />
  );
};

export default CloseButton;
